import { AdminDropdownsBaseController } from './admin_dropdowns_base_controller';

export default class extends AdminDropdownsBaseController {
  static targets = ['component', 'menu', 'menuItem'];

  static values = {
    width: String
  }

  connect() {
    // Handler bindings are now done in the base controller's initialize() method
  }

  toggleMenu() {
    this.closeAnyOpenMenu();
    this._positionMenu(event.target);
    this.showMenu();

    // This will reduce the number of events fired on the page by only listening to clicks when a
    // menu is open.
    if (this.menuTarget.classList.contains('open')) {
      document.addEventListener('click', this.clickOutsideHandler);
    } else {
      document.removeEventListener('click', this.clickOutsideHandler);
    }
  }

  closeDropdown() {
    this.closeMenu();
  }

  _positionMenu() {
    const closestRelativeElem = event.target.closest('.relative');

    const dropdownCoords = this.componentTarget.getBoundingClientRect();
    let closestRelativeElemCoords;

    if (closestRelativeElem) {
      closestRelativeElemCoords = closestRelativeElem.getBoundingClientRect();
    }

    this._setMenuLeft(dropdownCoords, closestRelativeElemCoords);
    this._setMenuTop(dropdownCoords, closestRelativeElemCoords);
    this.menuTarget.style.width = this.widthValue || `${dropdownCoords.width}px`;
  }

  // This method overwrites the main method in the base controller because button can be close
  // to the page edge and menu can be outside of page is position is corrected
  _setMenuLeft(dropdownCoords, closestRelativeElemCoords) {
    if (closestRelativeElemCoords) {
      if (this._menuOverflowingPage(dropdownCoords)) {
        this.menuTarget.style.left = `${ dropdownCoords.left - closestRelativeElemCoords.left - (this._menuWidthInPixels() - dropdownCoords.width)}px`;
      } else {
        this.menuTarget.style.left = `${ dropdownCoords.left - closestRelativeElemCoords.left }px`;
      }
    } else {
      if (this._menuOverflowingPage(dropdownCoords)) {
        this.menuTarget.style.left = `${ dropdownCoords.left - (this._menuWidthInPixels() - dropdownCoords.width) }px`;
      } else {
        this.menuTarget.style.left = `${ dropdownCoords.left }px`;
      }
    }
  }
  _menuOverflowingPage(coords) {
    return (coords.right + this._menuWidthInPixels()) > window.innerWidth;
  }

  _menuWidthInPixels() {
    if (!this.widthValue) return this.componentTarget.getBoundingClientRect().width;
    return parseFloat(this.widthValue) * parseFloat(getComputedStyle(document.documentElement).fontSize);
  }
}
